import { Link } from "react-router-dom";

export default function ArticleHero() {
  return (
    <section className="relative w-full h-[360px] md:h-[460px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20laptop%20showing%20spreadsheet%20and%20fashion%20products%20on%20screen%2C%20warm%20cream%20desk%20with%20coffee%20and%20notebook%2C%20soft%20natural%20lighting%2C%20editorial%20photography%2C%20clean%20aesthetic%2C%20neutral%20warm%20tones%2C%20professional%20organized%20desk%2C%20cozy%20atmosphere&width=1800&height=900&seq=article-hero-v2&orientation=landscape"
        alt="Poradnik Kakobuy Spreadsheet"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 h-full flex flex-col justify-end pb-12 md:pb-16 px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-block px-3 py-1 rounded-full border border-white/30 text-white/90 text-xs font-medium mb-4 whitespace-nowrap">
            Poradnik SEO
          </span>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight">
            Kompletny Przewodnik po Kakobuy Spreadsheet — Jak Znaleźć Najlepsze Produkty
          </h1>

          <p className="mt-4 text-white/80 text-sm md:text-base leading-relaxed max-w-xl">
            Wszystko co musisz wiedzieć o arkuszu Kakobuy — od podstaw po zaawansowane techniki wyszukiwania produktów
          </p>

          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 rounded-full bg-background-50 text-foreground-900 text-sm font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line text-sm"></i>
            Wróć do Strony Głównej
          </Link>
        </div>
      </div>
    </section>
  );
}